import React from 'react';

import {
  compose,
  lifecycle,
  withHandlers,
  withStateHandlers,
  withProps,
} from 'recompose';
import { withTranslation } from 'react-i18next';
import config from 'config';

import { withScriptjs, withGoogleMap } from 'react-google-maps';

import Map from 'components/DriverMap/Map/component';

import { getRoute, getStopMarkers, getDriverMarker } from './utils';

const loadingElement = <div />;
const containerElement = (
  <div style={{ height: `100%`, position: 'relative' }} />
);
const mapElement = <div style={{ height: `100%` }} />;

const enhance = compose(
  withTranslation('DriverMap'),
  withProps(() => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    containerElement,
    mapElement,
    loadingElement,
  })),
  withScriptjs,
  withGoogleMap,

  withStateHandlers(
    ({
      initialStopMarkers = [],
      initialDriverMarker = null,
      initialStopDirections = null,
      initialErrorFetchingDriver = false,
    }) => ({
      stopMarkers: initialStopMarkers,
      driverMarker: initialDriverMarker,
      stopDirections: initialStopDirections,
      errorFetchingDriver: initialErrorFetchingDriver,
    }),
    {
      handleUpdateMapState:
        () =>
        ({ stopMarkers, driverMarker, stopDirections }) => ({
          stopMarkers,
          driverMarker,
          stopDirections,
        }),
      handleErrorFetchingDriverPosition: () => () => ({
        errorFetchingDriver: true,
      }),
    }
  ),
  withHandlers({
    handleGetMapsData:
      ({ stops = [], handleUpdateMapState, drivers, handleShowError }) =>
      async () => {
        const DirectionsService = new window.google.maps.DirectionsService();

        const stopMarkers = getStopMarkers(stops);
        const stopsRoute = getRoute(stopMarkers);
        const driverMarker = await getDriverMarker(drivers, handleShowError);

        DirectionsService.route(stopsRoute, (result, status) => {
          if (status !== window.google.maps.DirectionsStatus.OK) {
            console.error(`error fetching directions ${result}`);

            handleUpdateMapState({
              stopMarkers,
              driverMarker,
              stopDirections: null,
            });

            return;
          }
          handleUpdateMapState({
            stopMarkers,
            driverMarker,
            stopDirections: result,
          });
        });
      },
  }),
  lifecycle({
    componentDidMount() {
      const { handleGetMapsData } = this.props;

      handleGetMapsData();
    },
  })
);

export default enhance(Map);
